var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-black flex flex-col sm:px-6 lg:px-8 h-screen"},[_c('Videos',{attrs:{"type":_vm.type},on:{"video-selected":_vm.onVideoSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }